<template>
  <div class="dashboard-page-wrapper test-page">
    <div class="top-wrap">
      <div class="text-img">
        <h2> Constant Composition Expansion </h2>
        <div>
          <div v-if="pdfLoader === true" class="test-pdf-div">
            <div class="img-content">
              <img :src="pdf_loader_image" alt="loader Image" />
            </div>
          </div>
          <div v-else @click="goToPdf()" class="test-pdf-div">
            <div class="img-content">
              <img :src="pdf_icon" alt="pdf icon" />
            </div>
          </div>
        </div>
      </div>
      <div class="top-content" v-if="showLoaders == true">
        <test-loaders />
      </div>
      <div class="top-content" v-else>
        <v-img src="../../../assets/Images/Assets/top image.png" alt="test image" width="49px" height="49px"></v-img>
        <div class="fields-info">
          <div class="fields-info-wrap" :style="{
            display: 'grid',
            gridTemplateColumns: 'repeat(4, 1fr)',
            gap: '16px'
          }">
            <div v-for="(item, index) in cceHeaderData.filter(i => !i.originalKey.endsWith('_UOM'))" :key="index" class="field-item">
              <p style="margin: 0; font-weight: 500;">{{ item.displayName }}</p>
              <p class="test-top-values" style="margin: 0;">
                <v-tooltip location="top">
                  <template v-slot:activator="{ props }">
                    <span v-bind="props" v-if="item.value == null" class="value-text">-</span>
                    <span v-bind="props" v-else-if="typeof item.value === 'number'" class="value-text">
                      {{ item.digits != 0 ? item.value.toFixed(item.digits) : item.value }}
                    </span>
                    <span v-bind="props" v-else class="value-text">{{ item.value }}</span>
                  </template>
                  <span>{{ item.value }}</span>
                </v-tooltip>
                <span v-if="cceHeaderData.some(i => i.originalKey === item.originalKey + '_UOM')" class="uom">
                  &nbsp;{{cceHeaderData.find(i => i.originalKey === item.originalKey + '_UOM').value}}
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <chartLoaders v-if="showLoaders == true"></chartLoaders>
    <screen-loader v-if="showLoaders == true"></screen-loader>
    <div v-else-if="timeoutMessage != ''" class="tabs-no-test-div timeout">
      <div class="text-center">
        {{ timeoutMessage }}
        <v-icon flat @click="loadItems()" color="blue-darken-3" icon="mdi-reload" size="large"></v-icon>
      </div>
    </div>
    <v-card-text class="tabs-data chart-table-wrap2" v-else-if="serverItems.length > 0 && showLoaders == false">
      <!-- <v-select
        v-model="selectedSort"
        label="Sort Step Pressure"
        :items="sortOptions"
        @update:modelValue="onSelectSort"
      >
      </v-select> -->
      <div class="chart-wrap" v-if="hasStepPressure">
        <div v-for="(variable, index) in variables" :key="index" class="chart-column">
          <div class="modal-tab-div">
            <div class="tab-div">
              <p>Y Axis Scale:</p>
              <v-btn-toggle v-model="isYLog[variable]" class="axis-toggle setHeight" mandatory
                @update:modelValue="handleYScaleToggleChange(variable)">
                <v-btn :value="true" class="switch-btn" outlined>Log</v-btn>
                <v-btn :value="false" class="switch-btn" outlined>Linear</v-btn>
              </v-btn-toggle>
            </div>
          </div>
          <div class="chart-name-top">
            <h6>{{ getHeaderDisplayNameChartTitle(variable) }}</h6>
          </div>
          <div :ref="`chart-${index}`" class="main-chart">
          </div>


          <v-dialog v-model="isPreviewOpen[index]" class="multi-chart-preview-div dashboard-chart-preview composition">
            <v-card class="position-relative studio-card">
              <v-card-text>
                <div class="popup-top">
                  <div class="modal-tab-div">
                    <div class="tab-div">
                      <p>Y Axis Scale:</p>
                      <v-btn-toggle v-model="isModalYLog[index]" class="axis-toggle setHeight" mandatory
                        @update:modelValue="handleModalYScaleToggleChange(index)">
                        <v-btn :value="true" class="switch-btn" outlined>Log</v-btn>
                        <v-btn :value="false" class="switch-btn" outlined>Linear</v-btn>
                      </v-btn-toggle>
                    </div>
                  </div>
                  <div class="chart-name-top w-100">
                    <h6>{{ getHeaderDisplayNameChartTitle(variable) }}</h6>
                  </div>
                  <!-- <img :src="cross" alt="cross" @click="closeModal(index)" class="chart-preview-close-btn"> -->
                </div>
                <div :ref="`modal-chart-${index}`" class="modal-chart-container"></div>
              </v-card-text>
            </v-card>
          </v-dialog>
        </div>
      </div>
      <div v-else-if="!hasStepPressure" class="text-center pt-5 pb-1">
        <h4>Charts couldn't be plotted as step pressure is not available in this test.</h4>
      </div>
      <div class="table-wrap">
        <div class="table-title-div" v-if="serverItems.length > 0">
          <p class="table-title">Constant Composition Expansion</p>
          <div class="csv-btn" @click="downloadTableCSV">
            <v-img class="pointer" :src="documentDownload" alt="csv download"></v-img>
          </div>
        </div>
        <v-data-table :headers="headers" :items="serverItems" :total-items="totalItems" :items-per-page="itemsPerPage"
          :loading="loading" :search="search" :item-value="name" virtual-items fixed-header
          max-height="calc(100vh - 335px)">
          <template v-slot:headers>
            <tr class="main-header">
              <th v-for="(header, index) in headers" :key="index" class="sticky-header">
                {{ header.name }}
                <span @click="handleHeaderClick(header.key)">
                  <span v-if="header.key === 'stepPressure'">
                    <v-icon v-if="sortOrder === 'asc'" @click.stop="sortStepPressure('desc')"
                      small>mdi-arrow-down</v-icon>
                    <v-icon v-else @click.stop="sortStepPressure('asc')" small>mdi-arrow-up</v-icon>
                  </span>
                </span>
              </th>
            </tr>
            <tr class="sub-header">
              <th v-for="(header, index) in headers" :key="index">
                {{ header.unit }}
              </th>
            </tr>
          </template>
          <template v-slot:body="{ items }">
            <tr v-for="(item, index) in items" :key="index">
              <td v-for="(header, index) in headers" :key="index">
                {{ displayValue(header.key, item[header.key]) }}
              </td>
            </tr>
          </template>
        </v-data-table>
      </div>
    </v-card-text>
    <div v-else-if="(!serverItems || serverItems.length === 0) && showLoaders == false" class="no-test-div">
      <h4>No data available.</h4>
    </div>
    <v-snackbar v-model="snackbarMessage" color="#E53535" timeout="3000" v-if="snackbarMessage != null">
      Error : {{ snackbarMessage }}
    </v-snackbar>
    <!-- <Filters @drawerStateChanged="handleRightDrawerStateChange" /> -->
  </div>
</template>

<script>
import Plotly from "plotly.js-dist-min";
import ChartLoaders from "../Loaders/ChartLoaders.vue";
import axios from "axios";
import TestLoaders from "../Loaders/TestLoaders.vue";
import ScreenLoader from "../Loaders/ScreenLoader.vue";
import { getDisplayName, getSortOrder } from '../../../utils/cache';
import { blobFromSampleReportResponse } from '../../../utils/sampleReportDownload';
import api from "../../../axiosInterceptor";
// import Filters from "../../../components/layout/Common/Filters.vue";
// import screenWidthMixin from "../../../assets/JS/screenWidthMixin";

import downloadIcon from '../../../assets/Svg/Chart/csv_chart.svg';
import camIcon from '../../../assets/Svg/camIcon.svg';
import Expand from "../../../assets/Svg/Chart/expand-btn.svg";
import { mapGetters } from "vuex";

export default {
  name: "CceData",
  components: {
    ChartLoaders,
    TestLoaders,
    ScreenLoader,
    // Filters,
  },
  data: () => ({
    showLoaders: true,
    itemsPerPage: 0,
    headers: [],
    serverItems: [],
    loading: true,
    totalItems: 0,
    tenantId: localStorage.getItem("tenantId"),
    variables: ["1", "2"],
    isPreviewOpen: Array().fill(false),
    chartData: Array().fill(null),
    cachedData: {},
    testID: "",
    testName: "",
    sampleID: "",
    fluidSampleID: "",
    hasStepPressure: false,
    saturationPressure: "",
    saturationPressure_UOM: "",
    testTemperature: "",
    testTemperature_UOM: "",
    assetName: "",
    fieldName: "",
    wellName: "",
    documentDownload: require("../../../assets/Images/csv.svg"),
    pdf_icon: require("../../../assets/Images/pdfIcon.svg"),
    pdf_loader_image: require("../../../assets/Images/pdfLoader.gif"),
    cross: require("../../../assets/Svg/Chart/chart-cross.svg"),
    pdfLoader: false,
    snackbarMessage: null,
    // selectedSort: "High to Low",
    // sortOptions: ["High to Low", "Low to High"],
    sortOrder: 'desc',
    timeoutMessage: "",
    yAxisScales: {},
    isYLog: {},
    modalYAxisScales: {},
    isModalYLog: {},
    headsortOrder: "",
    cceHeaderData: {}
  }),
  // mixins: [screenWidthMixin],
  computed: {
    ...mapGetters("darkMode", ["isDarkMode"]),
    hasXAxisVariable() {
      return this.serverItems.some(item => item.hasOwnProperty('stepPressure') || this.variables.some(variable => item.hasOwnProperty(variable)));
    },
  },
  methods: {
    // ...mapActions("metaData", ["getDisplayName"]),
    // onSelectSort() {
    //   const sortOrder = this.selectedSort === "High to Low" ? 0 : 1; // Set sort order based on selection

    //   this.loadItems({ sortOrder })
    //     .then((ccetest) => {
    //       this.variables.forEach((variable, index) => {
    //         this.plotChartForVariable(variable, index, ccetest);
    //       });
    //     })
    //     .catch((error) => {
    //       console.error("Error loading data:", error);
    //     });
    // },
    handleYScaleToggleChange(variable) {
      // Initialize default linear scale for the variable if not exists
      if (this.yAxisScales[variable] === undefined) {
        this.yAxisScales[variable] = 'linear';
      }

      this.yAxisScales[variable] = this.isYLog[variable] ? "log" : "linear";

      // Find the correct chart index
      const chartIndex = this.variables.indexOf(variable);

      this.modalYAxisScales[chartIndex] = this.yAxisScales[variable];
      if (this.modalYAxisScales[chartIndex] === "log") {
        this.isModalYLog[chartIndex] = true;
      }
      else {
        this.isModalYLog[chartIndex] = false;
      }
      // Re-plot the chart using the full response data
      if (this.cachedCceTest) {
        this.plotChartForVariable(variable, chartIndex, this.cachedCceTest);
      }
    },
    handleModalYScaleToggleChange(index) {
      // Initialize default linear scale for the variable if not exists
      if (this.modalYAxisScales[index] === undefined) {
        this.modalYAxisScales[index] = 'linear';
      }

      this.modalYAxisScales[index] = this.isModalYLog[index] ? "log" : "linear";

      this.plotModalChart(index)
    },
    sortStepPressure(order) {
      this.sortOrder = order;
      if (order === 'asc') {
        this.serverItems.sort((a, b) => a.stepPressure - b.stepPressure);
      } else {
        this.serverItems.sort((a, b) => b.stepPressure - a.stepPressure);
      }
    },
    downloadChartCSV(index) {
      const chartData = this.chartData[index];

      // Check if chart data exists
      if (chartData) {
        const fileName = `${chartData.layout.yaxis.title.text} vs ${chartData.layout.xaxis.title.text} data.csv`;

        // Prepare CSV header dynamically
        const csvHeader = [
          chartData.layout.xaxis.title.text,
          chartData.layout.yaxis.title.text,
        ];

        // Prepare CSV rows
        const csvRows = chartData.trace.x.map((xValue, i) => [
          xValue,
          chartData.trace.y[i],
        ]);

        // Concatenate header and rows
        const csvContent = [
          csvHeader.join(","),
          ...csvRows.map((row) => row.join(",")),
        ].join("\n");

        // Create Blob with CSV content
        const blob = new Blob([csvContent], {
          type: "text/csv;charset=utf-8;",
        });

        // Create link element to trigger download
        const link = document.createElement("a");
        if (link.download !== undefined) {
          const url = URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.setAttribute("download", fileName); // Set filename
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } else {
          console.error(
            "Your browser does not support downloading files programmatically. Please try a different browser."
          );
        }
      }
    },

    async loadItems() {
      var sampleId = localStorage.getItem("sampleId");
      var cceId = localStorage.getItem("testId");
      this.loading = true;
      this.showLoaders = true;
      this.timeoutMessage = "";

      try {
        let response = await api.get(
          `public/api/samples/${sampleId}/ccetests/${cceId}`
        );
        if (response && response.data && (response.data.statusCode === 200 || response.data.statusCode === 201)) {
          this.cachedCceTest = response.data.data.ccetest;
          this.serverItems =
            response.data.data.ccetest && response.data.data.ccetest.CCETestStep
              ? response.data.data.ccetest.CCETestStep
              : [];
          this.totalItems =
            response.data.data.ccetest && response.data.data.ccetest.length
              ? response.data.data.ccetest.length
              : 0;
          this.headsortOrder = await getSortOrder("ccetests", "cceTest", "header");
          const headerData = [];
          const cceHeader = response.data.data.pageData.cceTestHeader;

          if (cceHeader && Array.isArray(cceHeader)) {
            // Sort header items according to headsortOrder
            const sortedHeader = [...cceHeader].sort((a, b) => {
              const indexA = this.headsortOrder.indexOf(a.key);
              const indexB = this.headsortOrder.indexOf(b.key);
              return indexA - indexB;
            });

            for (const item of sortedHeader) {
              const { key, value } = item;
              
              // Convert display key to camelCase for getDisplayName
              const camelCaseKey = key
                .split(' ')
                .map((word, index) => 
                  index === 0 
                    ? word.toLowerCase() 
                    : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
                )
                .join('');

              let displayName, digits;
              try {
                const res = await getDisplayName('ccetests', camelCaseKey);
                displayName = res.displayName || key;
                digits = res.digits != null ? res.digits : 0;
              } catch {
                displayName = key;
                digits = 0;
              }

              headerData.push({
                originalKey: camelCaseKey,
                value: value, // Keep the full value including unit
                displayName,
                digits
              });
            }
          }
          this.cceHeaderData = headerData;

          // Fetch sort order from cache
          const sortOrder = await getSortOrder("ccetests", "cceTest", "table");
          this.serverItems.sort((a, b) => b.stepPressure - a.stepPressure);

          const sortByKeys = sortOrder.map(key =>
            key.charAt(0).toLowerCase() + key.slice(1)
          );
          // Check if serverItems contains stepPressure
          this.hasStepPressure = this.serverItems.some(item => item.hasOwnProperty('stepPressure'));

          const availableKeys = new Set(
            sortByKeys.filter((key) =>
              this.serverItems.some((item) => key in item)
            )
          );

          const allKeys = sortByKeys.filter((key) => availableKeys.has(key));

          // Update variables array with extracted keys, excluding stepPressure and testNumber
          this.variables = Array.from(allKeys).filter(
            (key) => key !== "stepPressure" && key !== "stepNumber"
          );

          const allUniqueKeys = Array.from(allKeys);

          const displayNames = [];
          const digitsArray = [];

          await Promise.all(
            allUniqueKeys.map(async (key) => {
              const fullKey = `cceTestSteps${key}`; // Concatenate at start
              const capitalizedKey = fullKey.charAt(0) + fullKey.slice(1);
              const { displayName, digits } = await getDisplayName("ccetests", capitalizedKey);
              displayNames.push(displayName);
              digitsArray.push(digits);
            })
          );

          // Update the headers array to use display names
          this.headers = Array.from(allKeys).map((key, index) => {
            const uom = this.serverItems.find((item) => item[key + "_UOM"]);
            const name = displayNames[index]; // Use display name instead of key
            let unit = uom ? uom[key + "_UOM"] : '-';
            // Check if unit is empty or equals "data-not-available", then set it to "-"
            if (!unit || unit === "data-not-available") {
              unit = "-";
            }
            const digits = digitsArray[index] || 0;
            return {
              key: key,
              name: name,
              unit: unit,
              digits: digits, // Add digits to headers
            };
          });

          return response.data.data.ccetest;
        }
        else if (response && response.data && response.data.message) {
          this.timeoutMessage = response.data.message;
        }
        else {
          this.timeoutMessage = "Error in fetching data";
        }
      } catch (error) {
        this.timeoutMessage = error;
        // console.error("Error fetching data:", error);
      } finally {
        this.loading = false;
        this.showLoaders = false;
      }
    },

    goToPdf() {
      this.snackbarMessage = null;
      this.pdfLoader = true;
      const sampleId = this.sampleID;
      axios
        .get(process.env.VUE_APP_API_URL + `public/api/samples/${sampleId}/download`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
            "X-TenantID": this.tenantId,
          },
          responseType: 'blob',
        })
        .then(async (response) => {
          const result = await blobFromSampleReportResponse(response, 'pdf');
          this.pdfLoader = false;
          if (!result.ok) {
            this.snackbarMessage = result.message;
            return;
          }
          const url = URL.createObjectURL(result.blob);
          window.open(url, '_blank');
        })
        .catch(async (error) => {
          this.pdfLoader = false;
          const data = error.response?.data;
          if (data instanceof Blob) {
            try {
              const text = await data.text();
              const j = JSON.parse(text);
              if (j && j.message) {
                this.snackbarMessage = j.message;
                return;
              }
            } catch (_) {
              /* fall through */
            }
          }
          if (error.response) {
            this.snackbarMessage = "The PDF report is not available for synthetic data in this study/sample/test. Please explore tests/samples under Asset: Public Data to check the power of this feature.";
          }
        })
        .finally(() => {
          this.pdfLoader = false;
        });
    },

    async plotChartForVariable(variable, chartIndex, ccetest) {
      if (!ccetest || !ccetest.CCETestStep) {
        return;
      }

      // Find the digits value for the current variable
      const header = this.headers.find(header => header.key === variable);
      const digits = header ? header.digits : 0;

      // Find the digits value for the stepPressure variable
      const stepPressureHeader = this.headers.find(header => header.key === 'stepPressure');
      const stepPressureDigits = stepPressureHeader ? stepPressureHeader.digits : 0;

      // Filter and map the data points together
      const filteredData = ccetest.CCETestStep
        .filter(step => step.stepPressure !== undefined && step.stepPressure !== null && step[variable] !== undefined && step[variable] !== null)
        .map(step => ({
          x: step.stepPressure,
          y: step[variable].toFixed(digits)
        }));

      const trace = {
        x: filteredData.map(data => data.x),
        y: filteredData.map(data => data.y),
        type: "scatter",
        mode: "lines+markers",
        name: variable,
        line: {
          color: "#2199A8",
          width: 2
        },
        marker: {
          color: "#2199A8",
          size: 8,
          line: {
            color: "#2199A8",
            width: 1
          }
        }
      };

      const layout = {
        // title: {
        //   text: `${this.getHeaderDisplayName(variable)} vs Pressure - CCE`,
        //   font: {
        //     size: 12,
        //   },
        // },
        xaxis: { 
            title: "Pressure (psia)", 
            gridcolor: this.isDarkMode ? '#74839A' : '#EFEFEF',
         },
        yaxis: {
          title: {
            text: this.getHeaderDisplayName(variable),
            standoff: 20
          },
          type: this.yAxisScales[variable] || "linear",
          automargin: true,
          gridcolor: this.isDarkMode ? '#74839A' : '#EFEFEF',
        },
        margin: {
          l: 50,
          r: 0,
          b: 120
        },
      };

      const config = {
        responsive: true,
        displaylogo: false,
        displayModeBar: true,
        modeBarButtonsToRemove: ["lasso2d", "select2d", "pan2d", "resetscale", "zoom", "toImage"],
        modeBarButtonsToAdd: [
          {
            name: "Expand",
            icon: {
              svg: `
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                  <image href="${Expand}" width="24" height="24"/>
                </svg>
              `,
            },
            click: this.openModal.bind(this, chartIndex),
          },
          {
            name: "Download CSV",
            icon: {
              svg: `
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                  <image href="${downloadIcon}" width="24" height="24"/>
                </svg>
              `,
            },
            click: this.handleDownloadCSV.bind(this, chartIndex),
          },
          {
            name: "Download plot as a png",
            icon: {
              svg: `
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                  <image href="${camIcon}" width="24" height="24"/>
                </svg>
              `,
            },
            click: this.handleDownloadPNG.bind(this, chartIndex),
          },
        ],
      };
      this.chartData[chartIndex] = {
        trace: trace,
        layout: layout,
        config: config,
      };

      const chartRef = this.$refs["chart-" + chartIndex];
      if (chartRef && chartRef.length > 0) {
        const chartElement = chartRef[0];
        Plotly.newPlot(chartElement, [trace], layout, config);
      } else {
        return
      }
    },

    getHeaderDisplayName(variable) {
      const header = this.headers.find(header => header.key === variable);
      if (header) {
        return header.unit !== '-' ? `${header.name} (${header.unit})` : header.name;
      }
      return variable;
    },
    getHeaderDisplayNameChartTitle(variable) {
      const header = this.headers.find(header => header.key === variable);
      if (header) {
        return header.name;
      }
      return variable;
    },

    displayValue(key, value) {
      const header = this.headers.find(header => header.key === key);
      const digits = header ? header.digits : 0; // Get digits from header

      if (value !== null && value !== undefined) {
        // Check if value is a string to avoid formatting
        if (typeof value === 'string') {
          return value;
        } else {
          // Format the value with the specified number of decimal places
          const numValue = Number(value);
          if (!isNaN(numValue)) {
            return digits > 0 ? numValue.toFixed(digits) : value;
          }
        }
      } else {
        return "-";
      }
    },

    downloadTableCSV() {
      // Check if table has items
      if (this.serverItems && this.serverItems.length > 0) {
        const fileName = `constant_composition_expansion_table.csv`;

        // Prepare CSV header dynamically from table headers
        const csvHeader = this.headers.map((header) => header.name);
        const csvUnits = this.headers.map((header) => header.unit);

        // Prepare CSV rows from table data
        const csvRows = this.serverItems.map((item) =>
          this.headers.map((header) => item[header.key])
        );

        // Concatenate header and rows
        const csvContent = [
          csvHeader.join(","),
          csvUnits.join(","),
          ...csvRows.map((row) => row.join(",")),
        ].join("\n");

        // Create Blob with CSV content
        const blob = new Blob([csvContent], {
          type: "text/csv;charset=utf-8;",
        });

        // Create link element to trigger download
        const link = document.createElement("a");
        if (link.download !== undefined) {
          const url = URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.setAttribute("download", fileName); // Set filename
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } else {
          console.error(
            "Your browser does not support downloading files programmatically. Please try a different browser."
          );
        }
      } else {
        console.error("No data available in the table to download.");
      }
    },

    handleDownloadCSV(chartIndex) {
      this.downloadChartCSV(chartIndex);
    },

    handleDownloadPNG(chartIndex) {
      this.downloadChartPNG(chartIndex);
    },

    downloadChartPNG(index) {
      const chartElement = this.$refs[`chart-${index}`];
      if (chartElement && chartElement[0]) {
        const chartData = this.chartData[index];
        const fileName = chartData ? 
          `${chartData.layout.yaxis.title.text} vs ${chartData.layout.xaxis.title.text}` :
          `Chart ${index}`;

        // Create a temporary div for the download
        const tempDiv = document.createElement('div');
        tempDiv.style.position = 'absolute';
        tempDiv.style.left = '-9999px';
        tempDiv.style.top = '-9999px';
        document.body.appendChild(tempDiv);

        // Create layout with title
        const layoutWithTitle = { ...chartData.layout };
        layoutWithTitle.title = {
          text: fileName,
          font: {
            size: 16,
            color: '#333'
          },
          x: 0.5,
          y: 0.95
        };

        // Create the temporary plot with title
        Plotly.newPlot(tempDiv, [chartData.trace], layoutWithTitle, {
          displayModeBar: false,
          responsive: true
        }).then(() => {
          // Download the PNG with title included
          Plotly.downloadImage(tempDiv, {
            format: 'png',
            filename: fileName || 'chart',
            height: 600,
            width: 800
          }).then(() => {
            // Clean up the temporary div
            document.body.removeChild(tempDiv);
          });
        });
      }
    },

    openModal(index) {
      this.isPreviewOpen[index] = true;
      this.$nextTick(() => {
        this.plotModalChart(index);

      });
    },

    closeModal(index) {
      this.isPreviewOpen[index] = false;
    },
    // Reload all charts when dark mode changes to update colors
    reloadAllCharts() {
      if (this.cachedCceTest) {
        this.variables.forEach((variable, index) => {
          this.plotChartForVariable(variable, index, this.cachedCceTest);
        });
      }
    },
    plotModalChart(index) {
      const chartData = this.chartData[index];
      if (chartData) {
        const modalChartRef = this.$refs[`modal-chart-${index}`][0];
        Plotly.Plots.resize(modalChartRef);
        Plotly.newPlot(
          modalChartRef,
          [chartData.trace],
          chartData.layout,
          chartData.layout.yaxis.type = this.modalYAxisScales[index],
          chartData.config
        );
      }
    },
  },
  watch: {
    $route(to, from) {
      // Call the loadItems method when route parameters change
      this.loadItems()
        .then((ccetest) => {
          this.variables.forEach((variable, index) => {
            this.plotChartForVariable(variable, index, ccetest);
          });
        })
        .catch((error) => {
          console.error("Error loading data:", error);
        });
    },
    // Watch for dark mode changes to reload plots and update colors
    isDarkMode() {
      this.reloadAllCharts();
    }
  },
  mounted() {
    this.assetName = this.$route.params.asset.replace(/-/g, " ");
    this.fieldName = this.$route.params.field.replace(/-/g, " ");
    this.wellName = this.$route.params.well;
    this.loadItems().then((ccetest) => {
      this.variables.forEach((variable, index) => {
        this.isYLog[variable] = false;
        this.isModalYLog[index] = false;
        this.plotChartForVariable(variable, index, ccetest);
      });
    });
  },
};
</script>